import type { KeyClubClubAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'
import type { InitialKeyClubSelectData } from '@/client/services/keyClub'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import KeyClubDistrictQ from './KeyClubDistrictQ'

const KeyClubClubQ = {
  ...makeQueryModelV2<KeyClubClubAttributes>('key_club_club')([
    'id',
    'name',
    'code',
    'key_club_district_id',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    KeyClubDistrict: {
      query: KeyClubDistrictQ,
      foreignKey: KeyClubDistrictQ.id,
      sourceKey: KeyClubClubQ.key_club_district_id,
    },
  }),

  getInitialKeyClubSelectData: (): SQLFragment<InitialKeyClubSelectData> => SQL`
      jsonb_build_object(
        'id', ${KeyClubClubQ.id},
        'name', ${KeyClubClubQ.name},
        'districtId', ${KeyClubClubQ.key_club_district_id},
        'clubsInDistrict', (
            SELECT jsonb_agg(jsonb_build_object('id', k2.id, 'name', k2.name))
            FROM key_club_club k2
            WHERE k2.key_club_district_id = ${KeyClubClubQ.key_club_district_id}
        )
    )`,

  where: (
    {
      id,
      code,
      keyClubDistrictId,
      groupBy = null,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      code?: string | null | SQLFragment<string>
      keyClubDistrictId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<KeyClubClubAttributes> => SQL`
        FROM ${KeyClubClubQ}
        ${includeAssociationsToSql(KeyClubClubQ, include)}
        WHERE
            ${id != null ? SQL`${KeyClubClubQ.id} = ${id} AND` : SQL``}
            ${code != null ? SQL`${KeyClubClubQ.code} = ${code} AND` : SQL``}
            ${
              keyClubDistrictId != null
                ? SQL`${KeyClubClubQ.key_club_district_id} = ${keyClubDistrictId} AND`
                : SQL``
            }
            ${paranoid ? SQL`${KeyClubClubQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default KeyClubClubQ
